<template>
  <div>

    <b-overlay
      :show="loading"
      spinner-variant="primary"
      spinner-type="grow"
      spinner-small
      rounded="sm"
    >
      <!-- Breadcrumb -->
      <app-breadcrumb>
        <template #contentright>
          <span class="text-nowrap" />

        </template>
      </app-breadcrumb>
      <b-row>
        <b-col md="12">
          <b-card aria-hidden="true">
            <!-- Alert: No item found -->
            <!-- <b-alert
              variant="danger"
              :show="errorMessage !== ''"
            >
              <h4 class="alert-heading">
                {{ errorMessage }}
              </h4>

            </b-alert> -->

            <!-- BODY -->
            <validation-observer
              #default="{ handleSubmit }"
              ref="refFormObserver"
            >
              <!-- Form -->
              <b-form
                class=""
                @submit.prevent="handleSubmit(onSubmit)"
                @reset.prevent="resetForm"
              >
                <b-row>
                  <!-- Bên trái -->
                  <b-col>
                    <b-col
                      md="12"
                      class="row"
                    >
                      <b-col md="8">
                        <!-- Name -->
                        <validation-provider
                          #default="validationContext"
                          :name="$t('Tên công việc')"
                          rules="required"
                        >
                          <b-form-group>
                            <template #label>
                              <label class="d-block font-weight-bolder">Tên công việc <span class="text-danger">*</span></label>
                            </template>
                            <b-form-input
                              id="name"
                              v-model="itemData.name"
                              :state="getValidationState(validationContext)"
                              :disabled="true"
                            />

                            <b-form-invalid-feedback>
                              {{ validationContext.errors[0] }}
                            </b-form-invalid-feedback>
                          </b-form-group>
                        </validation-provider>
                      </b-col>
                      <b-col md="4">

                        <validation-provider
                          #default="validationContext"
                          :name="$t('Danh mục công việc')"
                          rules="required"
                        >
                          <b-form-group label-for="category_work_id">
                            <template #label>
                              <label class="d-block font-weight-bolder">Danh mục công việc <span class="text-danger">*</span></label>
                            </template>
                            <v-select
                              v-model="itemData.category_work_id"
                              :options="dataCategoryWork"
                              :reduce="val => val.id"
                              label="name"
                              placeholder="--Chọn--"
                              :disabled="true"
                            />
                            <b-form-invalid-feedback :state="getValidationState(validationContext)">
                              {{ validationContext.errors[0] }}
                            </b-form-invalid-feedback>
                          </b-form-group>
                        </validation-provider>
                      </b-col>
                    </b-col>
                    <b-col
                      md="12"
                      class="row"
                    >
                      <b-col md="8">
                        <!-- Mô tả -->
                        <b-form-group>
                          <template #label>
                            <label class="d-block font-weight-bolder">Nội dung </label>
                          </template>
                          <b-form-textarea
                            id="description"
                            v-model="itemData.content"
                            rows="4"
                            :disabled="true"
                          />
                        </b-form-group>
                      </b-col>
                      <b-col md="4">
                        <b-form-group
                          id="group_finished_volume"
                          style="margin-bottom: 0px;"
                        >
                          <b-card-text>
                            <p class="d-block font-weight-bolder">
                              Khối lượng công việc <span style="color:red">{{ itemData.finished_volume }}%</span>
                            </p>
                          </b-card-text>
                        </b-form-group>

                        <vue-slider v-model="itemData.finished_volume" />

                        <!-- <b-form-group id="group_finished_volume">

                          <template #label>
                            <label class="d-block font-weight-bolder">Khối lượng công việc</label>
                          </template>

                          <b-form-input
                            id="finished_volume"
                            v-model="itemData.finished_volume"
                            type="range"
                            min="0"
                            max="100"
                          />
                          <span>{{ itemData.finished_volume }}%</span>

                        </b-form-group> -->
                        <validation-provider
                          #default="validationContext"
                          :name="$t('Mức độ ưu tiên')"
                          rules="required"
                        >
                          <b-form-group label-for="manager_id">
                            <template #label>
                              <label class="d-block font-weight-bolder">Mức độ ưu tiên <span class="text-danger">*</span></label>
                            </template>
                            <v-select
                              v-model="itemData.priority"
                              :options="priorityOptions"
                              :reduce="val => val.id"
                              label="name"
                              placeholder="--Chọn--"
                              :disabled="true"
                            />
                            <b-form-invalid-feedback :state="getValidationState(validationContext)">
                              {{ validationContext.errors[0] }}
                            </b-form-invalid-feedback>
                          </b-form-group>
                        </validation-provider>
                        <validation-provider
                          #default="validationContext"
                          :name="$t('Trạng thái')"
                          rules="required"
                        >
                          <b-form-group label-for="status">
                            <template #label>
                              <label class="d-block font-weight-bolder">Trạng thái <span class="text-danger">*</span></label>
                            </template>
                            <v-select
                              v-model="itemData.status"
                              :options="statusOptions"
                              :reduce="val => val.id"
                              label="name"
                              placeholder="--Chọn--"
                              :disabled="true"
                            />
                            <b-form-invalid-feedback :state="getValidationState(validationContext)">
                              {{ validationContext.errors[0] }}
                            </b-form-invalid-feedback>
                          </b-form-group>
                        </validation-provider>
                      </b-col>
                    </b-col>
                    <b-col
                      md="12"
                      class="row"
                    >
                      <b-col md="8">
                        <!-- Người thực hiện -->
                        <validation-provider
                          #default="validationContext"
                          :name="$t('Người thực hiện')"
                          rules="required"
                        >
                          <b-form-group label-for="manager_id">
                            <template #label>
                              <label class="d-block font-weight-bolder">Người thực hiện <span class="text-danger">*</span></label>
                            </template>
                            <v-select
                              v-model="itemData.main_user_id"
                              :options="dataUser"
                              :reduce="val => val.id"
                              label="full_name"
                              placeholder="--Chọn--"
                              :disabled="true"
                            />
                            <b-form-invalid-feedback :state="getValidationState(validationContext)">
                              {{ validationContext.errors[0] }}
                            </b-form-invalid-feedback>
                          </b-form-group>
                        </validation-provider>
                      </b-col>
                      <b-col md="4">
                        <validation-provider
                          #default="validationContext"
                          vid="begin_date"
                          name="Thời gian bắt đầu"
                          rules="required"
                        >
                          <b-form-group
                            label="Thời gian bắt đầu"
                            label-for="begin_date"
                          >
                            <template #label>
                              <label class="d-block font-weight-bolder pb-0">Thời gian bắt đầu<span class="text-danger">*</span></label>
                            </template>
                            <flat-pickr
                              v-model="itemData.begin_date"
                              class="form-control"
                              :config="configDate"
                              placeholder="dd-mm-yyyy hh:i"
                              theme="dark"
                              :state="getValidationState(validationContext)"
                              :disabled="true"
                            />
                            <b-form-invalid-feedback :state="getValidationState(validationContext)">
                              {{ validationContext.errors[0] }}
                            </b-form-invalid-feedback>
                          </b-form-group>
                        </validation-provider>

                      </b-col>
                    </b-col>
                    <b-col
                      md="12"
                      class="row"
                    >
                      <b-col md="8">
                        <!-- Người phối hợp thực hiện -->
                        <b-form-group label-for="manager_id">
                          <template #label>
                            <label class="d-block font-weight-bolder">Người phối hợp thực hiện </label>
                          </template>
                          <v-select
                            v-model="itemData.data_list_user_collaborators"
                            :options="dataUser"
                            :reduce="val => val.id"
                            label="full_name"
                            placeholder="--Chọn--"
                            :multiple="true"
                            :no-drop="true"
                            :clearable="false"
                            :searchable="false"
                          />
                          <b-badge
                            v-for="(item) in itemData.data_list_user_collaborators"
                            :key="item.id"
                            pill
                            variant="secondary"
                          >{{ item.full_name }}</b-badge>

                        </b-form-group>
                      </b-col>
                      <b-col md="4">

                        <validation-provider
                          #default="validationContext"
                          vid="end_date"
                          name="Thời gian kết thúc"
                          rules="required"
                        >
                          <b-form-group
                            label="Thời gian kết thúc"
                            label-for="end_date"
                          >
                            <template #label>
                              <label class="d-block font-weight-bolder pb-0">Thời gian kết thúc<span class="text-danger">*</span></label>
                            </template>
                            <flat-pickr
                              v-model="itemData.end_date"
                              class="form-control"
                              :config="configDate"
                              placeholder="dd-mm-yyyy hh:i"
                              theme="dark"
                              :disabled="true"
                              :state="getValidationState(validationContext)"
                            />
                            <b-form-invalid-feedback :state="getValidationState(validationContext)">
                              {{ validationContext.errors[0] }}
                            </b-form-invalid-feedback>
                          </b-form-group>
                        </validation-provider>
                      </b-col>
                    </b-col>

                    <b-col
                      md="12"
                      class="row"
                    >
                      <b-col md="8" />
                      <!-- File -->
                      <b-col cols="12">
                        <b-form-group>
                          <div class="attachedFiles">
                            <!-- <upload-files :files="frmData.attachedFiles"
                              :card_type="card_type"
                              @updateAttachedFile="handAttchedFiles" /> -->
                            <div class="fileupload">
                              <div class="d-flex">
                                <div class="mr-2">
                                  <label class="d-block font-weight-bolder pb-0">Đính kèm</label>
                                </div>
                                <div>
                                  <file-upload
                                    ref="uploadAttach"
                                    v-model="attachedFiles"
                                    class="btn btn-blue btn-sm"
                                    :post-action="api_upload"
                                    :headers="custom_header"
                                    :drop="true"
                                    accept="image/*,application/*,audio/*,video/*"
                                    :multiple="true"
                                    input-id="attachedFiles"
                                    :add-index="true"
                                    :size="3000 * 1024 * 1024"
                                    @input-file="inputFileAttach"
                                  >
                                    <feather-icon icon="UploadIcon" /> Upload từ máy tính </file-upload>
                                </div>
                              </div>
                            </div>
                            <div
                              v-if="attachedFiles.length > 0"
                              class="showData mt-1"
                            >
                              <table class="table table-striped">
                                <tbody>
                                  <tr
                                    v-for="(file, index) in attachedFiles"
                                    :key="index"
                                  >
                                    <td>
                                      <span :class="getExtention(file)" />
                                    </td>
                                    <td>
                                      <p class="mb-0">
                                        <strong>{{ file.name }}</strong>
                                      </p>
                                      <p
                                        v-if="file.error"
                                        class="text-danger fs_9 font-weight mb-0"
                                      >Tải lên thất bại</p>
                                      <div v-else>
                                        <p
                                          v-if="file.success || file.uploaded"
                                          class="text-success fs_9 font-weight mb-0"
                                        >Đã tải xong</p>
                                        <p
                                          v-else
                                          class="mb-0 size"
                                        >{{ formatFileSize(file.speed) }}/{{ formatFileSize(file.size) }}</p>
                                        <div
                                          v-if="!file.success && !file.uploaded"
                                          class="progress progress-bar-success"
                                        >
                                          <div
                                            :class="{ 'progress-bar': true, 'progress-bar-striped': true, 'bg-danger': file.error, 'progress-bar-animated': file.active }"
                                            role="progressbar"
                                            :style="{ width: file.progress + '%' }"
                                          />
                                        </div>
                                      </div>
                                    </td>
                                    <td
                                      class="text-center align-middle"
                                      width="100"
                                    >{{ (file.progress) ? file.progress.replace('.00', '') : '100' }}%</td>
                                    <td
                                      class="text-center align-middle"
                                      width="100"
                                    >{{ formatFileSize(file.size) }}</td>
                                    <td
                                      v-if="file.success || file.uploaded"
                                      width="70"
                                      class="text-center align-middle"
                                    >
                                      <span
                                        class="icon_delete"
                                        @click.prevent="onDeleteAttach(file)"
                                      />
                                    </td>
                                    <td
                                      v-if="!file.success && !file.uploaded"
                                      class="text-center align-middle"
                                      width="60"
                                    >
                                      <span
                                        v-if="file.error"
                                        class="icon_delete"
                                        @click.prevent="$refs.uploadAttach.remove(file)"
                                      />
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </b-form-group>
                      </b-col>
                    </b-col>
                  </b-col>

                </b-row>

                <!-- Form Actions -->
                <div class="d-flex mt-2">
                  <b-button
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="primary"
                    class="mr-2"
                    type="submit"
                  >
                    {{ $t('Save') }}
                  </b-button>
                </div>

              </b-form>
            </validation-observer>
          </b-card>

        </b-col>
      </b-row>
    </b-overlay>

  </div>
</template>

<script>
import {
  BRow, BCol, BCard, BOverlay, BForm, BFormGroup, BButton, BFormInput, BFormInvalidFeedback,
  BFormTextarea, BBadge, BCardText,
} from 'bootstrap-vue'
import {
  ref, reactive, toRefs,
} from '@vue/composition-api'
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import Ripple from 'vue-ripple-directive'
import flatPickr from 'vue-flatpickr-component'
import { Vietnamese } from 'flatpickr/dist/l10n/vn'
import vSelect from 'vue-select'
import moment from 'moment'
import VueSlider from 'vue-slider-component'
import { getToken } from '@/auth/utils'
import {
  apiUpload, apiDownload,
} from '@/libs/initTinymce'
import AppBreadcrumb from '@core/layouts/components/AppBreadcrumb.vue'
import formValidation from '@core/comp-functions/forms/form-validation'
import {
  required, alphaNum, alphaNumDot, max, integer, positive,
} from '@validations';
import { useRouter, showToast } from '@core/utils/utils';
import store from '@/store'
import OriginalFile from './OriginalFile.vue'

export default {
  components: {
    AppBreadcrumb,
    BRow,
    BCol,
    BCard,
    BOverlay,
    BForm,
    BFormGroup,
    BButton,
    BFormInput,
    BFormInvalidFeedback,
    ValidationProvider,
    ValidationObserver,
    vSelect,
    flatPickr,
    BFormTextarea,
    OriginalFile,
    BBadge,
    VueSlider,
    BCardText,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      required,
      integer,
      alphaNum,
      alphaNumDot,
      max,
      positive,
      devices: [],
      itemDevice: [],
      studioId: integer,
      // items: [],
      forceUpdate: 0,

    }
  },
  watch: {
  },
  methods: {
    inputFilter(newFile, oldFile, prevent) {
      if (newFile && !oldFile) {
        if (!/\.(jpeg|jpe|jpg|gif|png|webp|mp3|mp4|wav|webm)$/i.test(newFile.name)) {
          this.$swal({
            title: '',
            html: '<b>Chỉ hỗ trợ định dạng:</b> jpg, png, jpeg, git, webp, mp3, wav, mp4, webm',
            allowOutsideClick: true,
            customClass: {
              confirmButton: 'btn btn-primary',
            },
            buttonsStyling: false,
          })
          return prevent()
        }
      }
    },
    // inputFile(newFile, oldFile) {
    //   if (Boolean(newFile) !== Boolean(oldFile) || oldFile.error !== newFile.error) {
    //     if (!this.$refs.upload.active) {
    //       this.$refs.upload.active = true
    //     }
    //   }

    //   if (newFile) {
    //     newFile.full_path = ''
    //     newFile.extension = newFile.name.split('.').pop().toLowerCase();
    //     if (['jpg', 'png', 'gif', 'jpeg', 'webp'].includes(newFile.extension)) {
    //       this.tabActive = 'image'
    //     } else if (['mp4', 'webm'].includes(newFile.extension)) {
    //       this.tabActive = 'video'
    //     } else {
    //       this.tabActive = 'audio'
    //     }
    //   }

    //   if (newFile && newFile.success) {
    //     if (newFile.response.code == 400) {
    //       newFile.error = 'Tải file thất bại'
    //     }
    //   }
    //   if (newFile && newFile.success) {
    //     if (newFile.response.code === 200) {
    //       newFile.fileId = newFile.response.data.id;
    //       newFile.full_path = newFile.response.data.full_path;
    //       newFile.extension = newFile.response.data.extension
    //       const result = newFile.response.data;
    //       const item = {
    //         id: result.id,
    //         extension: result.extension,
    //         size: newFile.size,
    //         uploaded: 1,
    //         file: result.file,
    //         name: result.name,
    //         uuid: result.uuid,
    //         mimetype: result.mimetype,
    //         full_path: result.full_path,
    //         type: result.type,
    //       }
    //       this.attachedFiles.push(item)
    //       console.log('this.attachedFiles-inputfile', this.attachedFiles);
    //     }
    //   }
    // },
    formatFileSize(bytes, decimals) {
      if (bytes == 0) return '0 Bytes';
      const k = 1024;
      const dm = decimals || 2;
      const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
    },
    getExtention(file) {
      const fileExt = file.name.split('.').pop().toLowerCase();
      let cssClass = '';
      if (['docx', 'doc'].includes(fileExt)) {
        cssClass = 'icon_docx'
      } else if (['pdf'].includes(fileExt)) {
        cssClass = 'icon_pdf'
      } else if (['csv', 'xlsx', 'xls'].includes(fileExt)) {
        cssClass = 'icon_xls'
      } else if (['mp4', 'webm'].includes(fileExt)) {
        cssClass = 'icon_clip'
      } else if (['mp3', 'wav'].includes(fileExt)) {
        cssClass = 'icon_music'
      } else {
        cssClass = 'icon_img'
      }
      return cssClass;
    },
    inputFileAttach(newFile, oldFile) {
      if (Boolean(newFile) !== Boolean(oldFile) || oldFile.error !== newFile.error) {
        if (!this.$refs.uploadAttach.active) {
          this.$refs.uploadAttach.active = true
        }
      }
      if (newFile && newFile.error) {
        newFile.error = 'Tải lên thất bại'
      } else if (newFile && newFile.success && newFile.error == '') {
        if (newFile.response.code == 400) {
          newFile.error = 'Tải file thất bại'
        }
      }
      if (newFile && newFile.success) {
        if (newFile.response.code === 200) {
          newFile.fileId = newFile.response.data.id;
          newFile.full_path = newFile.response.data.full_path;
          newFile.extension = newFile.response.data.extension
          const result = newFile.response.data;
          const item = {
            id: result.id,
            extension: result.extension,
            size: newFile.size,
            uploaded: 1,
            file: result.file,
            name: result.name,
            uuid: result.uuid,
            mimetype: result.mimetype,
            full_path: result.full_path,
            type: result.type,
          }
          this.frmFiles.push(item)
        }
      }
    },
    onDeleteAttach(file) {
      if (this.attachedFiles.length > 0) {
        const attachedFiles = this.attachedFiles.filter((item) => item.id !== file.id)
        this.$refs.uploadAttach.remove(file);
        this.frmFiles = attachedFiles;
      }
    },
  },
  setup(props, context) {
    const { route, router } = useRouter();
    const id = ref(route.value.params.id !== undefined ? route.value.params.id : 0);
    const layout = ref(route.value.name !== 'devices-edit' ? 'add' : 'edit');
    // const loading = ref(!!id.value)
    const loading = ref(true)
    const errorMessage = ref('')
    const dataCategoryWork = ref([])
    const dataUser = ref([])
    const accessToken = getToken()
    const attachedFiles = ref([])
    const frmFiles = ref([])
    const custom_header = ref({
      Authorization: `Bearer ${accessToken}`,
    });
    const state = reactive({
      api_upload: apiUpload,
      api_download: apiDownload,
    })
    const statusOptions = [
      { name: 'Đang thực hiện', id: 10 },
      { name: 'Đang chờ xác nhận hoàn thành', id: 20 },
      { name: 'Hoàn thành', id: 30 },
      { name: 'Từ chối', id: 40 },
    ];
    const priorityOptions = [
      { name: 'Cao', id: 10 },
      { name: 'Trung bình', id: 20 },
      { name: 'Bình thường', id: 30 },
      { name: 'Thấp', id: 40 },
    ];
    const defaultItemData = {
      name: '',
      content: '',
      status: 10,
      main_user_id: null,
      data_list_user_collaborators: [],
      note: '',
      finished_volume: 0,
      category_work_id: null,
      priority: 10,
    }
    const itemData = ref(JSON.parse(JSON.stringify(defaultItemData)))

    const resetItemData = () => {
      itemData.value = JSON.parse(JSON.stringify(defaultItemData))
    }
    const {
      refFormObserver,
      getValidationState,
      resetForm,
    } = formValidation(resetItemData)
    const formatDate = (value) => moment(String(value)).format('DD-MM-YYYY H:m')

    store.dispatch('listWork/fetchOne', { id: router.currentRoute.params.id })
      .then(response => {
        if (response.status === 200) {
          itemData.value = response.data.data
          frmFiles.value = itemData.value.data_files ? itemData.value.data_files : []
          attachedFiles.value = itemData.value.data_files ? itemData.value.data_files : []
          itemData.value.begin_date = formatDate(itemData.value.begin_date)
          itemData.value.end_date = formatDate(itemData.value.end_date)
          loading.value = false
        }
      })

    const onSubmit = () => {
      errorMessage.value = '';
      // loading.value = true;
      itemData.value.attachedFiles = frmFiles.value;
      // delete itemData.value.created_at;
      // delete itemData.value.category_work_id;
      // delete itemData.value.begin_date;
      // delete itemData.value.end_date;
      // delete itemData.value.name;
      // delete itemData.value.content;
      // delete itemData.value.created_by;
      // delete itemData.value.created_by_name;
      // delete itemData.value.data_list_user_collaborators;
      // delete itemData.value.main_user_id;
      // delete itemData.value.main_user_name;
      // delete itemData.value.priority;
      // delete itemData.value.updated_at;
      // delete itemData.value.updated_by;
      // delete itemData.value.updated_by_name;
      store.dispatch('listWork/updateAssigned', { data: itemData.value, id: itemData.value.id })
        .then((response) => {
          if (response.status === 200) {
            if (response.data.code === 200) {
              showToast(response.data.message, { variant: 'success' });
              resetForm()
              // emit('updateData')
              router.push({ name: 'work-list-assigned' })
            } else {
              showToast(response.data.message)
              errorMessage.value = response.data.message;
            }
          }
        })
    }
    const fetchCategoryWork = () => {
      store.dispatch('listWork/fetchAllCategoryWork', {
        isPaginate: 0,
      })
        .then(response => {
          if (response.data.code === 200) {
            dataCategoryWork.value = response.data.data;
          }
        })
    }
    fetchCategoryWork();

    const fetchManager = () => {
      store.dispatch('users/fetchUsers', {
        isPaginate: '0',
      })
        .then(response => {
          if (response.data.code === 200) {
            dataUser.value = response.data.data;
          }
        })
    }
    fetchManager();
    const today = new Date();
    const hour = today.getHours();
    const minutes = today.getMinutes();
    const configDate = ref({
      dateFormat: 'd-m-Y H:i',
      enableTime: true,
      locale: Vietnamese, // locale for this instance only
      defaultHour: hour,
      defaultMinute: minutes,
      time_24hr: true,
      theme: 'dark',
    });

    return {
      ...toRefs(state),
      id,
      layout,
      errorMessage,
      loading,
      itemData,
      // devices,
      refFormObserver,
      getValidationState,
      resetForm,
      resetItemData,
      onSubmit,
      // fetchData,
      dataUser,
      configDate,
      // convertCurrency,
      statusOptions,
      dataCategoryWork,
      priorityOptions,
      attachedFiles,
      frmFiles,
      custom_header,
    }
  },

}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

@import '@core/scss/vue/libs/vue-slider.scss';

@import '@core/scss/vue/libs/vue-flatpicker.scss';

#group_finished_volume>div {
  display: flex;
}

#finished_volume {
  margin-right: 15px;
}

.vs__dropdown-menu {
  display: none;
}

.vs__deselect {
  display: none;
}
</style>
